var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverlapMarkerImageSrcSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 20C43 29.0601 36.9757 36.7131 28.7143 39.1718C25.8571 40 23 45 23 45C23 45 20.1429 40 17.2857 39.1718C9.02432 36.7131 3 29.0601 3 20C3 8.9543 11.9543 0 23 0C34.0457 0 43 8.9543 43 20Z",
    fill: "#6F7282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 44.0447C22.977 44.0088 22.9531 43.9717 22.9284 43.9337C22.6099 43.4428 22.1543 42.7784 21.6063 42.0861C21.0594 41.3952 20.4134 40.6675 19.713 40.0554C19.0179 39.448 18.2399 38.9282 17.4267 38.6921C9.37234 36.2942 3.5 28.8322 3.5 20C3.5 9.23045 12.2304 0.5 23 0.5C33.7696 0.5 42.5 9.23045 42.5 20C42.5 28.8323 36.6276 36.2942 28.5732 38.6921C27.7601 38.9282 26.982 39.448 26.2871 40.0554C25.5866 40.6675 24.9406 41.3952 24.3937 42.0861C23.8457 42.7784 23.3901 43.4428 23.0716 43.9337C23.0469 43.9717 23.023 44.0088 23 44.0447Z",
    stroke: "#6F7282"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 17.5269C23.9108 17.5269 24.6495 18.2656 24.6495 19.1769C24.6495 20.0882 23.9108 20.8269 22.9995 20.8269C22.0882 20.8269 21.3495 20.0882 21.3495 19.1769C21.3495 18.2656 22.0882 17.5269 22.9995 17.5269Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 12.5769C23.9108 12.5769 24.6495 13.3156 24.6495 14.2269C24.6495 15.1382 23.9108 15.8769 22.9995 15.8769C22.0882 15.8769 21.3495 15.1382 21.3495 14.2269C21.3495 13.3156 22.0882 12.5769 22.9995 12.5769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 22.4769C23.9108 22.4769 24.6495 23.2156 24.6495 24.1269C24.6495 25.0382 23.9108 25.7769 22.9995 25.7769C22.0882 25.7769 21.3495 25.0382 21.3495 24.1269C21.3495 23.2156 22.0882 22.4769 22.9995 22.4769Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2904",
    x: 0,
    y: 0,
    width: 46,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2904",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlapMarkerImageSrcSelect);
export default __webpack_public_path__ + "static/media/overlapMarkerImageSrc_select.234f7e5d4b7caf8a1376e833e040f012.svg";
export { ForwardRef as ReactComponent };